import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GerarPdfService {

  constructor(
    private baseService: BaseService,
    private httpClient: HttpClient,
  ) { }

  URL_GERACAO_PDF = '/cnes/consulta/geracao-pdf';

  async getRelatorioRascunho(idRascunho: number | string, dto: any = {}) {
    const url = `${environment.urlBaseNova}${this.URL_GERACAO_PDF}/rascunho/${idRascunho}`;
    return await this.httpClient.post(url,dto, {
      headers: {
        Accept: 'application/json, application/pdf',
      },
      responseType: 'blob',
    }).toPromise();
  }

  async getRelatorioEstabelecimento(idRascunho: number | string, dto: any = {}) {
    const url = `${environment.urlBaseNova}${this.URL_GERACAO_PDF}/estabelecimento/${idRascunho}`;
    return await this.httpClient.post(url, dto, {
      headers: {
        Accept: 'application/json, application/pdf',
      },
      responseType: 'blob',
    }).toPromise();
  }

}
